module.exports = __webpack_public_path__ + "img/sbtn4.060ec190.png";